export default `:host {
  display: block;
  width: 100%;
  height: 100%;
}
:host slot {
  display: block;
}

:host([hidden]) {
  display: none;
}

:host([no-margins]) .ids-list-view .ids-list-view-body li:first-child,
:host([no-margins]) .ids-list-view .ids-list-view-body ids-list-view-item:first-child,
:host([no-margins]) .ids-list-view .ids-list-view-body ::slotted(li):first-child,
:host([no-margins]) .ids-list-view .ids-list-view-body ::slotted(ids-list-view-item):first-child {
  margin-block-start: var(--ids-space-none);
}

:host([searchable]) .ids-list-view-body:first-child,
.has-searchfield .ids-list-view-body:first-child {
  margin-block-start: 8px;
}

.ids-list-view {
  height: var(--ids-list-view-height);
  overflow: auto;
  position: relative;
}
.ids-list-view .ids-list-view-body {
  margin: 0;
  padding: 0;
}
.ids-list-view .ids-list-view-body:focus {
  border-color: var(--ids-list-view-color-border-focus);
}
.ids-list-view .ids-list-view-body li {
  padding: var(--ids-list-view-item-padding);
  background-color: var(--ids-list-view-item-color-background-default);
  border: var(--ids-list-view-item-border);
  border-top-color: var(--ids-list-view-item-color-border-top);
  contain: content;
  list-style-type: none;
}
.ids-list-view.selectable-multiple .list-item-area, .ids-list-view.selectable-mixed .list-item-area {
  display: flex;
  align-items: center;
}
.ids-list-view.selectable-multiple .list-item-area .list-item-checkbox, .ids-list-view.selectable-mixed .list-item-area .list-item-checkbox {
  padding-inline-end: var(--ids-space-20);
  flex-grow: 0;
  flex-shrink: 0;
  max-height: var(--ids-space-sm);
  max-width: var(--ids-space-sm);
}
.ids-list-view.selectable-multiple .list-item-area .list-item-checkbox[disabled]::part(checkmark), .ids-list-view.selectable-mixed .list-item-area .list-item-checkbox[disabled]::part(checkmark) {
  background-color: var(--ids-color-transparent);
}
.ids-list-view.bordered {
  border: var(--ids-list-view-item-border);
  border-color: var(--ids-list-view-item-color-border-top);
  border-radius: 8px;
}
.ids-list-view.is-scrolling {
  box-shadow: var(--ids-scroll-shadow);
  border-top: var(--ids-scroll-color-border-top);
}

ids-list-view-item.no-top-border {
  border-top-color: transparent;
}

ids-swappable-item {
  border-bottom-color: var(--ids-color-neutral-20);
  border: none;
  padding: inherit;
}
ids-swappable-item ids-list-view-item {
  padding-inline-start: 0;
  box-shadow: none;
  border: 1px solid transparent;
}
ids-swappable-item ids-list-view-item[selected], ids-swappable-item:hover::before {
  color: var(--ids-color-text-default);
}
ids-swappable-item:hover {
  background-color: var(--ids-list-view-color-background-selected);
}

ids-swappable-item[selected] {
  border: 1px solid var(--ids-list-view-item-color-border-focus);
}

ids-swappable-item[over] {
  border: 1px dashed var(--ids-color-neutral-80);
}

::slotted(ids-search-field) {
  margin-bottom: 8px;
}

.sortable .ids-list-view li:hover,
.sortable .ids-list-view li:focus,
.sortable .ids-list-view li:focus-visible,
.sortable .ids-list-view li:focus-within,
.sortable .ids-list-view ids-list-view-item:hover,
.sortable .ids-list-view ids-list-view-item:focus,
.sortable .ids-list-view ids-list-view-item:focus-visible,
.sortable .ids-list-view ids-list-view-item:focus-within,
.sortable .ids-list-view ::slotted(li:hover),
.sortable .ids-list-view ::slotted(li:focus),
.sortable .ids-list-view ::slotted(li:focus-visible),
.sortable .ids-list-view ::slotted(li:focus-within),
.sortable .ids-list-view ::slotted(ids-list-view-item:hover),
.sortable .ids-list-view ::slotted(ids-list-view-item:focus),
.sortable .ids-list-view ::slotted(ids-list-view-item:focus-visible),
.sortable .ids-list-view ::slotted(ids-list-view-item:focus-within),
[sortable] .ids-list-view li:hover,
[sortable] .ids-list-view li:focus,
[sortable] .ids-list-view li:focus-visible,
[sortable] .ids-list-view li:focus-within,
[sortable] .ids-list-view ids-list-view-item:hover,
[sortable] .ids-list-view ids-list-view-item:focus,
[sortable] .ids-list-view ids-list-view-item:focus-visible,
[sortable] .ids-list-view ids-list-view-item:focus-within,
[sortable] .ids-list-view ::slotted(li:hover),
[sortable] .ids-list-view ::slotted(li:focus),
[sortable] .ids-list-view ::slotted(li:focus-visible),
[sortable] .ids-list-view ::slotted(li:focus-within),
[sortable] .ids-list-view ::slotted(ids-list-view-item:hover),
[sortable] .ids-list-view ::slotted(ids-list-view-item:focus),
[sortable] .ids-list-view ::slotted(ids-list-view-item:focus-visible),
[sortable] .ids-list-view ::slotted(ids-list-view-item:focus-within),
:host(.sortable) li:hover,
:host(.sortable) li:focus,
:host(.sortable) li:focus-visible,
:host(.sortable) li:focus-within,
:host(.sortable) ids-list-view-item:hover,
:host(.sortable) ids-list-view-item:focus,
:host(.sortable) ids-list-view-item:focus-visible,
:host(.sortable) ids-list-view-item:focus-within,
:host(.sortable) ::slotted(li:hover),
:host(.sortable) ::slotted(li:focus),
:host(.sortable) ::slotted(li:focus-visible),
:host(.sortable) ::slotted(li:focus-within),
:host(.sortable) ::slotted(ids-list-view-item:hover),
:host(.sortable) ::slotted(ids-list-view-item:focus),
:host(.sortable) ::slotted(ids-list-view-item:focus-visible),
:host(.sortable) ::slotted(ids-list-view-item:focus-within),
:host([sortable]) li:hover,
:host([sortable]) li:focus,
:host([sortable]) li:focus-visible,
:host([sortable]) li:focus-within,
:host([sortable]) ids-list-view-item:hover,
:host([sortable]) ids-list-view-item:focus,
:host([sortable]) ids-list-view-item:focus-visible,
:host([sortable]) ids-list-view-item:focus-within,
:host([sortable]) ::slotted(li:hover),
:host([sortable]) ::slotted(li:focus),
:host([sortable]) ::slotted(li:focus-visible),
:host([sortable]) ::slotted(li:focus-within),
:host([sortable]) ::slotted(ids-list-view-item:hover),
:host([sortable]) ::slotted(ids-list-view-item:focus),
:host([sortable]) ::slotted(ids-list-view-item:focus-visible),
:host([sortable]) ::slotted(ids-list-view-item:focus-within) {
  cursor: default;
}
.sortable .ids-list-view ::slotted(ids-list-view-item[selected]),
[sortable] .ids-list-view ::slotted(ids-list-view-item[selected]),
:host(.sortable) ::slotted(ids-list-view-item[selected]),
:host([sortable]) ::slotted(ids-list-view-item[selected]) {
  color: var(--ids-color-text-default);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
